module.exports = __webpack_public_path__ + "images/hr-mon-next-to-phone.png";